export const locale = {
  lang: 'en',
  data: {
    BUTTON: {
      PROFILE: "Profile",
      LOGOUT: "Logout"
    }
  }
}
